import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function LegalPersonIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.6075 3.595C10.6075 2.164 9.4379 1 8 1C6.5621 1 5.39248 2.164 5.39248 3.595C5.39248 5.026 6.5621 6.19 8 6.19C9.4379 6.19 10.6075 5.026 10.6075 3.595ZM11.6123 3.595C11.6123 5.577 9.99156 7.19 8 7.19C6.00844 7.19 4.38766 5.577 4.38766 3.595C4.38766 1.613 6.00844 0 8 0C9.99156 0 11.6123 1.613 11.6123 3.595ZM7.39811 9.0666L8 9.8486L8.60189 9.0666C8.40293 9.0486 8.20297 9.0366 8 9.0366C7.79703 9.0366 7.59707 9.0486 7.39811 9.0666ZM6.91781 13.2446L8 14.3216L9.08219 13.2446L8 11.5886L6.91781 13.2446ZM0.5 15.4996C0.5 11.3846 3.86515 8.0366 8 8.0366C12.1348 8.0366 15.5 11.3846 15.5 15.4996C15.5 15.7766 15.2749 15.9996 14.9976 15.9996C14.7193 15.9996 14.4952 15.7766 14.4952 15.4996C14.4952 12.5256 12.4624 10.0206 9.7092 9.2706L8.61395 10.6956L10.1473 13.0386C10.2769 13.2366 10.2488 13.4976 10.081 13.6646L8.35571 15.3826C8.25723 15.4796 8.12862 15.5286 8 15.5286C7.87138 15.5286 7.74277 15.4796 7.64429 15.3826L5.91901 13.6646C5.75121 13.4976 5.72307 13.2366 5.85269 13.0386L7.38605 10.6956L6.2908 9.2706C3.53758 10.0206 1.50482 12.5256 1.50482 15.4996C1.50482 15.7766 1.28075 15.9996 1.00241 15.9996C0.72508 15.9996 0.5 15.7766 0.5 15.4996Z'
      />
    </svg>
  );
}
